import { BrowserView, MobileView } from 'react-device-detect';
import SimpleBar, { Props as SimpleBarProps } from 'simplebar-react';
import { cn } from 'utils/cn';

interface Props extends SimpleBarProps {
    children: React.ReactNode;
    className?: string;
}

/*
 * `!` throughout: simplebar's own stylesheet is unlayered, so it beats any utility that restyles the
 * parts it draws.
 */
const SCROLLBAR_CLASS = cn(
    'max-h-full',
    '[&_.simplebar-scrollbar]:before:bg-fg-secondary/48!',
    '[&_.simplebar-scrollbar.simplebar-visible]:before:opacity-100!',
    '[&_.simplebar-track.simplebar-vertical]:w-2.5!',
    '[&_.simplebar-track.simplebar-horizontal_.simplebar-scrollbar]:h-1.5!',
    '[&_.simplebar-mask]:z-[inherit]!'
);

/** A custom scrollbar on desktop browsers; plain horizontal overflow on mobile. */
export default function SimpleBarScroll({ children, className, ...other }: Props) {
    return (
        <>
            <BrowserView className="h-full grow overflow-hidden">
                <SimpleBar
                    timeout={500}
                    forceVisible
                    clickOnTrack={false}
                    className={cn(SCROLLBAR_CLASS, className)}
                    {...other}
                >
                    {children}
                </SimpleBar>
            </BrowserView>
            <MobileView>
                <div className={cn('overflow-x-auto', className)}>{children}</div>
            </MobileView>
        </>
    );
}
